import React, { Component } from 'react';
import debounce from 'lodash/debounce';

const withBoundingClientRect = WrappedComponent =>
  class extends Component {
    state = { boundingClientRect: {} };

    componentDidMount() {
      this.observer = new MutationObserver(() => {
        this.update();
      });
      const observerConfig = {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true,
      };

      this.observer.observe(this.wrapper, observerConfig);
      this.update();

      this.bindEvents();
    }

    componentWillUnmount() {
      this.unbindEvents();
    }

    bindEvents() {
      window.addEventListener('sidebar-updated', this.update);
      window.addEventListener('resize', this.update);
      window.addEventListener('animationend', this.update);
    }

    unbindEvents() {
      window.removeEventListener('sidebar-updated', this.update);
      window.removeEventListener('resize', this.update);
      window.removeEventListener('animationend', this.update);
    }

    update = debounce(() => {
      if (!this.wrapper) return;
      const { top, left, right, bottom, width, height } = this.wrapper.getBoundingClientRect();
      this.setState({
        boundingClientRect: {
          top,
          left,
          right,
          bottom,
          width,
          height,
        },
      });
    }, 150);

    render() {
      const newProps = {
        boundingClientRect: { ...this.state.boundingClientRect },
      };

      return (
        <div
          ref={(ref) => {
            this.wrapper = ref;
          }}
        >
          {<WrappedComponent {...this.props} {...newProps} />}
        </div>
      );
    }
  };

export default withBoundingClientRect;
